import type { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

/**
 * The selection model as an 'include' set. A header select-all arrives as `{ type: 'exclude', ids }` —
 * the rows NOT selected — so code that reads `model.ids` as the selection inverts: Delete disabled on
 * select-all, and a select-all-minus-one delete removing the unselected row. Normalizing at the
 * `onRowSelectionModelChange` boundary, against the rows that can be selected, keeps every reader an
 * 'include' reader (EntityListView resolves the same way for its bulk actions).
 */
export function toIncludeSelection(
  model: GridRowSelectionModel,
  selectableIds: readonly GridRowId[],
): GridRowSelectionModel {
  if (model.type !== 'exclude') return model;
  return { type: 'include', ids: new Set(selectableIds.filter((id) => !model.ids.has(id))) };
}
